import { useTranslation } from "react-i18next";
import SubTitle from "components/SubTitle";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Form, Button as BtButton, Row, Col } from "react-bootstrap";
import "./styles.scss";
import {
  useGetParametersQuery,
  useUpdateParametersMutation,
} from "features/api/usersPermissionsManagement/usersPermissionsManagementApiSlice";
import { PARAMETERS_CONFIG } from "./parametersUtils/ParametersUtils";

const ParametersManagement = () => {
  const { t } = useTranslation();
  const [initialValues, setInitialValues] = useState({});
  const [updateParameters, { isLoading: isUpdating, isError: updateError }] =
    useUpdateParametersMutation();

  const { data, isLoading, isError } = useGetParametersQuery();

  useEffect(() => {
    if (!data) return;

    const mappedValues = PARAMETERS_CONFIG.reduce((acc, param) => {
      const serverValue = data[param.name];
      const isValueExist =
        serverValue !== undefined && serverValue !== null && serverValue !== "";
      const isParsed = param.parse ? param.parse(serverValue) : serverValue;

      return {
        ...acc,
        [param.name]: isValueExist ? isParsed : param.defaultValue,
      };
    }, {});

    setInitialValues(mappedValues);
  }, [data]);

  const handleFormSubmit = (values) => {
    updateParameters(values);
    setInitialValues(values);
  };

  const formikProps = {
    initialValues,
    onSubmit: handleFormSubmit,
    enableReinitialize: true,
  };

  if (isLoading || isUpdating) return <div>Loading...</div>;

  return (
    <div className="parameters-container">
      <SubTitle className="title">{t("parameters")}</SubTitle>
      <Formik {...formikProps}>
        {({ handleSubmit, handleChange, values }) => {
          return (
            <Form>
              {PARAMETERS_CONFIG.map((param) => (
                <Form.Group as={Row} className="mb-3" key={param.name}>
                  <Form.Label column xs="auto">
                    {param.label}
                  </Form.Label>

                  <Col xs={1}>
                    <Form.Control
                      type={param.type}
                      name={param.name}
                      value={values[param.name]}
                      onChange={handleChange}
                    />
                  </Col>
                </Form.Group>
              ))}

              <BtButton
                variant="primary"
                className="update-parameters-button"
                onClick={() => handleSubmit()}
                // disabled={isLoading}
              >
                {t("update")}
              </BtButton>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ParametersManagement;
